import axios, { AxiosResponse } from 'axios';

const AUTH_TOKEN_KEY = 'rimafia-auth-token';

export const getStoredAuthToken = () => {
    if (typeof window === 'undefined') {
        return '';
    }

    return localStorage.getItem(AUTH_TOKEN_KEY) || '';
};

export const setStoredAuthToken = (token: string) => {
    if (typeof window === 'undefined') {
        return;
    }

    if (token) {
        localStorage.setItem(AUTH_TOKEN_KEY, token);
    }
};

export const clearStoredAuthToken = () => {
    if (typeof window === 'undefined') {
        return;
    }

    localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const normalizeAuthHeader = (value: string) => {
    if (!value) {
        return '';
    }

    return value.toLowerCase().startsWith('bearer ') ? value : `Bearer ${value}`;
};

export const extractAuthToken = (response: {
    data?: { body?: { token?: string; access_token?: string; authorization?: string } };
    headers?: AxiosResponse['headers'];
}) => {
    const body = response.data?.body;
    const header = response.headers?.authorization || response.headers?.Authorization;
    const token = body?.token || body?.access_token || body?.authorization || header || '';

    return token.replace(/^Bearer\s+/i, '');
};

export const getTelegramInitData = (): string => {
    if (typeof window === 'undefined') {
        return '';
    }

    return (window as any).Telegram?.WebApp?.initData || '';
};

export const getTelegramUserId = (): string => {
    if (typeof window === 'undefined') {
        return '';
    }

    const id = (window as any).Telegram?.WebApp?.initDataUnsafe?.user?.id;

    if (id) {
        return String(id);
    }

    // Outside Telegram there is no initData at all; the API only accepts a bare
    // user_id in dev environments, so the fallback must never reach production.
    return process.env.NODE_ENV === 'development' ? '1985764946' : '';
};

let reauthInFlight: Promise<void> | null = null;

/**
 * Re-runs POST /auth/auth to obtain a fresh session cookie. Uses the bare axios
 * export (no interceptors) so a failing re-auth can never recurse, and is
 * single-flight: any number of concurrently failing requests share one call.
 */
export const reauthorize = (botId: string): Promise<void> => {
    if (!reauthInFlight) {
        reauthInFlight = axios
            .post(
                '/auth/auth/',
                { user_id: getTelegramUserId(), init_data: getTelegramInitData() },
                {
                    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3010/',
                    withCredentials: true,
                    headers: {
                        'X-Bot-Id': botId,
                        'Accept-Language': 'uz-UZ'
                    }
                }
            )
            .then((response) => {
                const token = extractAuthToken(response);

                if (token) {
                    setStoredAuthToken(token);
                }
            })
            .finally(() => {
                reauthInFlight = null;
            });
    }

    return reauthInFlight;
};
